import React, { useEffect, useRef, useState } from 'react';
import '../App.css';



const SlideInDiv = ({ children }) => {
  const [isSliderVisible, seSlidertIsVisible] = useState(false);
  const slideInDivRef = useRef(null);

  const handleScroll = () => {
    if (slideInDivRef.current) {
      const elementTop = slideInDivRef.current.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (elementTop < windowHeight) {
        seSlidertIsVisible(true);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className={`slide-in-div ${isSliderVisible ? 'SliderVisible' : ''}`}
      ref={slideInDivRef}
    >
      {children}
    </div>
  );
};

export default SlideInDiv;
